/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Inject, Injectable } from '@angular/core';
import { IFittingTreeViewFacade } from '../../../../../data-access/src/lib/domain/facades-models/fitting-tree-view-facade-interface';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { FittingTreeView } from '../../models/fitting-tree-view-vm';
import { GetResultInformationFromTreeViewFolder } from './fitting-tree-view-actions';
import { selectTreeViewItems, selectUpdatedTreeViewItem } from './fitting-tree-view-selector';
import { ADD_FITTING_TAB_FACADE_TOKEN, IAddFittingTabFacade } from '../../../../../../toolbelt/data-access/src/lib/domain/facades-models/add-fitting-tab-facade-interface';
import { LocalStorageService } from '../../../../../../toolbelt/utils/src/lib/local-storage/local-storage.service';
import { FittingTreeViewState } from './fitting-tree-view-reducer';
import { FittingTreeViewComponent } from '../../components/add-fitting-tab/fitting-tree-view/fitting-tree-view.component';
import { FittingTreeViewService } from '../../../../../../toolbelt/utils/src/lib/fitting-tree-view.service';
import { BackendService } from '@hcworkspace/sysque/toolbelt/utils';

@Injectable({
  providedIn: 'root',
})
export class FittingTreeViewFacade implements IFittingTreeViewFacade {
  constructor(
    private store: Store<FittingTreeViewState>,
    @Inject(ADD_FITTING_TAB_FACADE_TOKEN) private addFittingTabFacade: IAddFittingTabFacade,
    public localStorageService: LocalStorageService,
    private fittingTreeViewService: FittingTreeViewService,
    private backendService: BackendService
  ) {}

  getResultInformationFromTreeViewFolder(validItems: FittingTreeView[]) {
    this.store.dispatch(GetResultInformationFromTreeViewFolder({ treeViewItems: validItems }));
  }

  updateTreeViewNodeOnExpansionChanged(itemData: any): Promise<any> {
    this.addFittingTabFacade.notifySelectorChange.next('treeView');
    return this.backendService.updateTreeViewNodeOnExpansionChanged(itemData);
  }

  getTreeViewItems(): Observable<any> {
    return this.store.select(selectTreeViewItems);
  }

  updateSelectorForResult() {
    this.addFittingTabFacade.notifySelectorChange.next('treeView');
  }

  getLocalStorageUpdate(): BehaviorSubject<string> {
    return this.localStorageService.localStorageUpdate$;
  }

  setFittingTreeViewInstance(fittingTreeView: FittingTreeViewComponent): void {
    this.fittingTreeViewService.setFittingTreeViewInstance(fittingTreeView);
  }
}
